import fields from './fields';
import events from './events';
import patient from './patient';
import titles from './titles';


export default {
  fields,
  events,
  patient,
  titles,
}
